/**************************************************
 * Nombre:       Tabs_Sub_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Tab, Tabs} from "@mui/material";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";

const Tabs_Sub_Categorias = ({escogido, setEscogido}) => {
    const [subCagegorias, setSubCagegorias] = useState([]);

    useEffect(() => {

        obtenerCol('subcategorias').then((dox) => {
            setSubCagegorias(dox.data);
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 0}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'center'}}>


                    <Tabs value={escogido} onChange={(e, v) => setEscogido(v)} variant={'scrollable'}
                          allowScrollButtonsMobile
                    >
                        <Tab label={'Todo'} value={'Todo'}/>
                        {subCagegorias.map((e, i) => (
                            <Tab label={e.nombre} value={e.nombre}/>
                        ))}

                    </Tabs>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tabs_Sub_Categorias